exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-payments .wrapper-main .pay-active2-success .text-container{background:#f8f8f8;border:1px solid #e4e4e4;border-radius:3px;padding:25px;max-width:680px;width:96%;margin:20px auto 0}.my-payments .wrapper-main .pay-active2-success .text-container p{line-height:1.65;color:#545454;font-size:16px;text-align:left;margin-left:80px;margin-top:0}.my-payments .wrapper-main .pay-active2-success .text-container img{float:left;max-width:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/dashboard/payments/signup/success/success.css
// module id = 772
// module chunks = 0